import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Badge from 'components/v2/Badge';
export default class FilterItem extends Component {
    render() {
        const { label } = this.props;
        return (React.createElement(Badge, { color: "blue", withRemove: true, onRemove: this.props.onRemoveFilter }, label));
    }
}
FilterItem.propTypes = {
    label: PropTypes.string.isRequired,
    onRemoveFilter: PropTypes.func.isRequired,
};
